import { createPlainTextComposerValue } from '#pplx/frontend/composer-sdk/createPlainTextComposerValue.js';
import { serializedStateToMarkdown } from '#pplx/frontend/composer-sdk/serializedStateToMarkdown.js';
const NO_SUBMISSION_ATTACHMENTS = {
    attachmentUrls: [],
    fileAttachments: [],
};
export function resolveComposerValue(value, json) {
    return json ?? createPlainTextComposerValue(value);
}
export function buildComposerSubmitParams({ submission, querySource, attachmentUrls = NO_SUBMISSION_ATTACHMENTS.attachmentUrls, fileAttachments = NO_SUBMISSION_ATTACHMENTS.fileAttachments, mentions, prefills, slashCommand, slashCommandSubmittedLabel, }) {
    const serializedQuery = serializedStateToMarkdown(submission.state);
    const firstFilename = fileAttachments[0]?.filename;
    // Match legacy AskInput: `file` is a transport sentinel, and this English fallback becomes
    // raw query/prompt content rather than localized display copy.
    const query = serializedQuery || firstFilename === undefined
        ? serializedQuery
        : firstFilename === 'file'
            ? 'File Attached'
            : firstFilename;
    return {
        query,
        json: submission.state,
        querySource,
        ...(attachmentUrls.length > 0 ? { attachments: [...attachmentUrls] } : {}),
        ...(fileAttachments.length > 0 ? { fileAttachments: [...fileAttachments] } : {}),
        ...(mentions !== undefined ? { mentions } : {}),
        ...(prefills !== undefined ? { prefills } : {}),
        ...(slashCommand !== undefined ? { slashCommand } : {}),
        ...(slashCommandSubmittedLabel !== undefined ? { slashCommandSubmittedLabel } : {}),
    };
}
//# sourceMappingURL=buildComposerSubmitParams.js.map